'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.List = exports.default = undefined;

var _List2 = require('./List');

var _List3 = _interopRequireDefault(_List2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _List3.default;
exports.List = _List3.default;


//////////////////
// WEBPACK FOOTER
// ./~/react-virtualized/dist/commonjs/List/index.js
// module id = 1979
// module chunks = 2